import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardMedia,
  Button,
  CircularProgress,
  IconButton,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import apilink from "../globals/Baseurls";
import imgPlaceholder from "./face1.png";
import heartsBg from "./hearts_bnk.png";

export default function Liked() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isPremium, setIsPremium] = useState(true); // toggle for premium/non-premium
  const navigate = useNavigate();

  const viewProfile = async (user_id) => {

    const obj = {
      user_id
    }
    try {
      obj.navto = "liked";
      localStorage.setItem("chatSessionData", JSON.stringify(obj));
      navigate(`/user-profile`)
    } catch (err) {
      console.error(err.message);
    }
  };

  useEffect(() => {
    const fetchLikes = async () => {
      try {
        const userData = JSON.parse(localStorage.getItem("userSessionData"));
        const token = userData.token;

        const response = await axios.get(`${apilink.link}/who-i-liked`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setUsers(response.data.users);
        console.log(response.data.users);
      } catch (err) {
        console.error(err.response?.data || err.message);
        alert("Failed to fetch users");
      } finally {
        setLoading(false);
      }
    };

    fetchLikes();
  }, []);

  if (loading)
    return <CircularProgress sx={{ mt: 4, display: "block", mx: "auto" }} />;

  return (
    <Box sx={{
      minHeight: "100vh", // full height
      backgroundImage: `
                    linear-gradient(to right, rgba(255,255,255,0.5), rgba(255,255,255,0.2)),
                    url(${heartsBg})
                    `,
      backgroundSize: "cover", // cover whole area
      backgroundPosition: "center", // center the image
      backgroundRepeat: "no-repeat", // don't repeat
      p: 2, // padding
    }}>
      {/* Top row: Back + toggle premium */}
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
        <Box display="flex" alignItems="center">
          <IconButton
            onClick={() => navigate("/activity")}
            sx={{
              bgcolor: "#f2f2f2", // light gray background
              borderRadius: "50%", // perfect circle
              p: 1, // padding inside circle
              "&:hover": {
                bgcolor: "#e0e0e0", // slightly darker on hover
              },
            }}
          >
            <ArrowBackIcon sx={{ color: "#33380" }} />
          </IconButton>

          <Typography variant="h6" ml={1}>
            Liked
          </Typography>
        </Box>
        <Button size="small" onClick={() => setIsPremium((prev) => !prev)}>
          {isPremium ? "Non-Premium View" : "Premium View"}
        </Button>
      </Box>

      {users.length === 0 && <Typography>You haven’t liked anyone yet, once you do, they’ll show up here</Typography>}

      <Box display="flex" flexDirection="column" gap={2}>
        {users.map((u) => (
          <Card
            key={u.id}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              p: 1.5,
              borderRadius: 3,
            }}
          >
            {/* Profile Image */}
            <CardMedia
              component="img"
              src={
                isPremium
                  ? u.profile_photo
                    ? `${apilink.base_link}/storage/${u.profile_photo}`
                    : imgPlaceholder
                  : "https://via.placeholder.com/60/cccccc?text=Blurred"
              }
              alt={u.profile.display_name}
              sx={{
                width: 60,
                height: 60,
                borderRadius: "50%",
                objectFit: "cover",
                mr: 2,
                filter: !isPremium ? "blur(4px)" : "none",
              }}
            />

            {/* Right Content */}
            <Box flex={1}>
              {/* ✅ Row 1: Name + Age */}
              <Typography fontWeight="bold" fontSize={16}>
                {u.profile.display_name} • {u.profile.age}
              </Typography>

              {/* ✅ Row 2: Like Type + Date (Same Line) */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  mt: 0.3,
                }}
              >
                {u.like_type === "like" && (
                  <Typography variant="body2" color="text.secondary">
                    👍 Like
                  </Typography>
                )}

                {u.like_type === "superlike" && (
                  <Typography variant="body2" fontWeight="bold" color="#010832">
                    ⭐ Super Like
                  </Typography>
                )}

                <Typography variant="body2" color="text.secondary">
                  • {new Date(u.liked_at).toLocaleDateString()}
                </Typography>
              </Box>

              {/* ✅ Row 3: Buttons Side by Side */}
              {isPremium && (
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    mt: 1,
                  }}
                >
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => navigate(`/chat/${u.id}`)}
                    sx={{
                      flex: 1,
                      textTransform: "none",
                      borderRadius: 2,
                    }}
                  >
                    Chat
                  </Button>

                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => viewProfile(u.id)}
                    sx={{
                      flex: 1,
                      textTransform: "none",
                      borderRadius: 2,
                    }}
                  >
                    View
                  </Button>
                </Box>
              )}
            </Box>
          </Card>

        ))}
      </Box>
    </Box>
  );
}

